module.exports = __webpack_public_path__ + "img/icon-tabler-filter.88367801.svg";